import React, { useEffect, useState } from 'react';
import { sharedTableStyles } from '../../utils/tableStyles';
import { TableSkeleton } from '../../components/UI/Skeleton/Skeleton';
import TableCard from '../../components/UI/TableToolbar/TableCard';
import TableToolbar from '../../components/UI/TableToolbar/TableToolbar';
import RowActionMenu from '../../components/UI/RowActionMenu/RowActionMenu';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import _debounce from 'lodash/debounce';

import {
  useAddLeaveTypeMutation,
  useDeleteLeaveTypeMutation,
  useEditLeaveTypeMutation,
  useGetLeaveTypeQuery
} from '../../redux/apis/LeaveType';
import { useGetDesignationQuery } from '../../redux/apis/Designation';
import { useGetEmployeeDropDownQuery } from '../../redux/apis/employee';

import './LeaveType.scss';
import { DepartmentsData } from '../../components/Data/AppData';
import EmptyData from '../../components/UI/EmptyData';
import DeleteModel from '../../components/common/DeleteModel';

import { notification } from '../../utils/notification';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import {
  GENDER_OPTION,
  INPUT_LABEL,
  MARITAL_STATUS_OPTION
} from '../../utils/constant/placeHolders';
import { leaveTypeSchema } from '../../utils/schemas/auth';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import { GLOBAL, EFFECTIVE_FROM, EFFECTIVE_PERIOD } from '../../utils/constant/global';
import {
  getErrorMessage,
  formatDate,
  paginationRow,
  skipRow,
  editDateFormate
} from '../../utils/handler';
import {
  LB_HEADER,
  LB_LEAVE_TYPE_TABLE_COLS,
  LB_LEAVE_TYPE_TABLE_COL_SORT
} from '../../utils/constant/labels';

let columnsT = '';

const initialState = {
  isModal: { model: false, submit: false },
  modalHeader: { title: '', isEdit: false, editId: '' },
  editLeaveTypeData: {},
  search: '',
  isDelete: { id: '', status: '' },
  selectEmployeeData: [],
  selectDesignationData: [],
  selectDepartMentData: {},
  selectGender: [],
  selectMaritalStatus: [],
  currentPage: 1,
  rowsPerPage: 10,
  isNext: false,
  sortField: 'createdAt',
  sortDirection: false,
  loading: false,
  dropdownDataStore: [],
  currentPageDropdown: 1,
  rowsPerPageDropdown: 50,
  dropdownDesignationData: [],
  currentPageDesignationDropdown: 1,
  rowsPerPageDropdownDesignation: 50
};

const { LB_ADD_NEW_LEAVE_TYPE, LB_EDIT_LEAVE_TYPE } = LB_HEADER;
const {
  LB_NAME,
  LB_GRANT,
  LB_ENTITLEMENT,
  LB_BALANCE,
  LB_TYPE,
  LB_CODE,
  LB_DESCRIPTION,
  LB_EFFECTIVE_AFTER,
  LB_APPLICABLE,
  LB_DELETE_LEAVE_TYPE,
  LB_DELETE_LEAVE_MESSAGE,
  LB_GENDER_LABEL,
  LB_LB_EMPLOYEE,
  LB_DESIGNATION_LABEL,
  LB_MARITAL_STATUS_LABEL,
  LB_EFFECTIVE_START,
  LB_EFFECTIVE_END,
  LB_CARRY_FORWARD,
  LB_NO_OF_DAYS,
  LB_PER,
  LB_FROM,
  LB_OR
} = INPUT_LABEL;
const { BTN_SAVE, BTN_NEW_LEAVE_TYPE } = BT_BUTTON_LABELS;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { DESC, ASC, EMPLOYEE_TYPE, DESIGNATION_TYPE } = GLOBAL;
const { LB_TBL_COL_LEAVE_TYPE, LB_TBL_COL_LEAVE_CODE, LB_TBL_COL_CREATED_AT, LB_TBL_COL_ACTION } =
  LB_LEAVE_TYPE_TABLE_COLS;
const { SR_LEAVE_TYPE } = LB_LEAVE_TYPE_TABLE_COL_SORT;

const leaveTypeTableStyles = {
  ...sharedTableStyles,
  headCells: {
    style: {
      ...sharedTableStyles.headCells.style,
      color: '#334155',
      fontWeight: 700
    }
  },
  rows: {
    ...sharedTableStyles.rows,
    style: {
      ...sharedTableStyles.rows.style,
      color: '#6b7280'
    }
  },
  cells: {
    style: {
      ...sharedTableStyles.cells.style,
      color: '#6b7280',
      fontWeight: 600
    }
  }
};

function LeaveType() {
  const [state, setState] = useState(initialState);

  const {
    data: leaveTypeData,
    isLoading,
    isFetching,
    refetch: leaveTypeFetch
  } = useGetLeaveTypeQuery({
    search: state.search,
    skip: skipRow(state.currentPage, state.rowsPerPage),
    limit: state.rowsPerPage,
    sort: state.sortField,
    sortType: state.sortDirection ? DESC : ASC
  });

  const { data: designationData, refetch: designationFetch } = useGetDesignationQuery({
    search: state.search,
    limit: state.rowsPerPageDropdownDesignation,
    skip: skipRow(state.currentPageDesignationDropdown, state.rowsPerPageDropdownDesignation)
  });

  const { data: dropdownData, refetch: employeeDropDownQuery } = useGetEmployeeDropDownQuery({
    skip: skipRow(state.currentPageDropdown, state.rowsPerPageDropdown),
    limit: state.rowsPerPageDropdown
  });

  const [addLeaveType] = useAddLeaveTypeMutation();
  const [editLeaveType] = useEditLeaveTypeMutation();
  const [deleteLeaveType] = useDeleteLeaveTypeMutation();

  const handleChangeSort = (sortField) => {
    setState({ ...state, sortDirection: !state.sortDirection, sortField: sortField.sortField });
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedSelectedCheckboxes;

    if (checked) {
      updatedSelectedCheckboxes = [...state.selectGender, value];
    } else {
      updatedSelectedCheckboxes = state.selectGender.filter((checkbox) => checkbox !== value);
    }

    setValue('gender', updatedSelectedCheckboxes);
    setState({ ...state, selectGender: updatedSelectedCheckboxes });
  };

  const handleMaritalStatusCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedSelectedCheckboxes;

    if (checked) {
      updatedSelectedCheckboxes = [...state.selectMaritalStatus, value];
    } else {
      updatedSelectedCheckboxes = state.selectMaritalStatus.filter(
        (checkbox) => checkbox !== value
      );
    }

    setValue('maritalStatus', updatedSelectedCheckboxes);
    setState({ ...state, selectMaritalStatus: updatedSelectedCheckboxes });
  };

  const {
    register,
    watch,
    reset,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(leaveTypeSchema)
  });

  const values = watch();

  columnsT = [
    {
      name: LB_TBL_COL_LEAVE_TYPE,
      sortField: SR_LEAVE_TYPE,
      selector: (row) => row?.name,
      sortable: true,
      minWidth: '220px',
      grow: 2,
      cell: (row) => <span className="leave-type-name">{row?.name || '-'}</span>
    },
    {
      name: LB_TBL_COL_LEAVE_CODE,
      selector: (row) => row?.code || '',
      sortable: false,
      minWidth: '140px',
      cell: (row) => <span className="leave-type-code">{row?.code || '-'}</span>
    },
    {
      name: LB_TBL_COL_CREATED_AT,
      selector: (row) => formatDate(row?.createdAt),
      sortable: false,
      minWidth: '160px',
      cell: (row) => <span className="leave-type-date">{formatDate(row?.createdAt) || '-'}</span>
    },
    {
      name: LB_TBL_COL_ACTION,
      selector: () => {},
      sortable: false,
      width: '88px',
      right: true,
      cell: (row) => (
        <RowActionMenu
          actions={[
            {
              label: 'Edit',
              icon: 'icofont-edit',
              variant: 'success',
              onClick: () => {
                handleSetEditData(row);
              }
            }
          ]}
        />
      )
    }
  ];

  const addLeaveTypeFunc = async (data) => {
    try {
      setState({ ...state, loading: true });
      const res = await addLeaveType(data);
      if (res?.data?.success) {
        leaveTypeFetch();
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
        setState({
          ...state,
          isModal: { model: false, submit: false },
          modalHeader: { title: '', isEdit: false, editId: '' },
          loading: false
        });
        reset();
      } else {
        reset();
        setState({
          ...state,
          isModal: { model: false, submit: false },
          modalHeader: { title: '', isEdit: false, editId: '' },
          loading: false
        });
        notification(res?.error?.data?.data?.message, TOAST_ERROR);
      }
    } catch (error) {
      notification(error?.data?.data?.message, TOAST_ERROR);
    }
  };

  useEffect(() => {
    if (state.isModal.model) {
      designationFetch();
      employeeDropDownQuery();
    }
  }, [state.isModal.model]);

  const isEditLeaveType = async (data, id) => {
    try {
      const editData = {
        data: data,
        id
      };

      setState({ ...state, loading: true });
      const res = await editLeaveType(editData);
      if (res?.data?.success) {
        leaveTypeFetch();
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
        setState({
          ...state,
          isModal: { model: false, submit: false },
          loading: false,
          modalHeader: { title: '', isEdit: false, editId: '' }
        });
      } else {
        reset();
        setState({
          ...state,
          isModal: { model: false, submit: false },
          loading: false,
          modalHeader: { title: '', isEdit: false, editId: '' }
        });
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      notification(error?.message, TOAST_ERROR);
    }
  };

  const onSubmit = (data) => {
    const effectiveStart = new Date(data?.effectiveStartDate).getTime();
    const effectiveEnd = new Date(data?.effectiveEndDate).getTime();

    const leaveTypeData = {
      name: data?.name,
      code: data.code,
      description: data.description,
      type: data.type,
      balanceBasedOn: data.balanceBasedOn,
      applicable: {
        gender: data.gender,
        maritalStatus: data.maritalStatus,
        designation: state.selectDesignationData,
        employee: state.selectEmployeeData
      }
    };

    if (data.balanceBasedOn === 'Entitlement') {
      leaveTypeData.entitlement = [
        {
          noOfDays: data?.numberOfDays,
          period: data?.period,
          validity: {
            startDate: effectiveStart,
            endDate: effectiveEnd
          },
          effectiveAfter: {
            from: data?.periodfrom
          },
          isCarryForward: data?.carryForward === 'Yes' ? true : false
        }
      ];
    } else if (data.balanceBasedOn === 'Grant') {
      leaveTypeData.grant = {
        noOfDays: data?.numberOfDays,
        period: data?.period,
        validity: {
          startDate: effectiveStart,
          endDate: effectiveEnd
        },
        isCarryForward: data?.carryForward === 'Yes' ? true : false
      };
    }

    setState({ ...state, isModal: { model: true, submit: true } });

    if (state?.editLeaveTypeData?._id) {
      isEditLeaveType(leaveTypeData, state?.editLeaveTypeData?._id);
    } else {
      addLeaveTypeFunc(leaveTypeData);
    }
  };

  const handleDeleteLeaveType = (id) => {
    try {
      deleteLeaveType(id).then((res) => {
        if (res?.data?.success) {
          leaveTypeFetch();
          setState({ ...state, isDelete: { id: '', status: false } });
        }
      });
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  useEffect(() => {
    leaveTypeFetch();
    setState({ ...state, isNext: leaveTypeData?.isNext });
  }, [state.rowsPerPage, state.currentPage, state.search, state.sortDirection]);

  const handleChangePage = (page) => {
    setState({ ...state, currentPage: page });
  };

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setState({ ...state, rowsPerPage: newRowsPerPage, currentPage: 1 });
  };

  const debouncedOnSearchData = _debounce((data) => {
    setState({ ...state, search: data });
  }, 300);

  const createLabelObject = (data, type) => {
    const labelArray = [];
    const labelIdArray = [];
    for (let i = 0; i < data?.length; i++) {
      const element = data[i];
      if (element._id) {
        if (type === EMPLOYEE_TYPE) {
          labelArray.push({ value: element._id, label: element.name });
          labelIdArray.push(element._id);
        } else if (type === DESIGNATION_TYPE) {
          labelArray.push({ value: element._id, label: element.name });
          labelIdArray.push(element._id);
        } else {
          labelArray.push({ value: element._id, label: element?.name });
          labelIdArray.push(element._id);
        }
      } else {
        labelArray.push({ value: element, label: element });
        labelIdArray.push(element);
      }
    }
    const labelData = {
      data: labelArray,
      id: labelIdArray
    };

    return labelData;
  };

  const handleEditApplicable = async (row) => {
    const employeeObj = createLabelObject(row?.applicable?.employee, EMPLOYEE_TYPE);
    const designationObj = createLabelObject(row?.applicable?.designation, DESIGNATION_TYPE);

    setState((prevState) => ({
      ...prevState,
      selectGender: row?.applicable?.gender,
      selectMaritalStatus: row?.applicable?.maritalStatus,
      selectDesignationData: designationObj.id,
      selectEmployeeData: employeeObj.id
    }));

    setValue('name', row?.name);
    setValue('code', row?.code);
    setValue('type', row?.type);
    setValue('balanceBasedOn', row?.balanceBasedOn);
    setValue('description', row?.description);
    setValue('EffectiveNumber', row?.entitlement?.[0]?.effectiveAfter?.value);
    setValue('time', row?.entitlement?.[0]?.effectiveAfter?.effectivePeriod);
    setValue('from', row?.entitlement?.[0]?.effectiveAfter?.from);
    setValue('gender', row?.applicable?.gender);
    setValue('maritalStatus', row?.applicable?.maritalStatus);

    if (row?.balanceBasedOn === 'Entitlement') {
      setValue('carryForward', row?.entitlement?.[0]?.isCarryForward ? 'Yes' : 'No');
      setValue('numberOfDays', row?.entitlement?.[0]?.noOfDays);
      setValue('period', row?.entitlement?.[0]?.period);
      setValue('periodfrom', row?.entitlement?.[0]?.effectiveAfter?.from);
      setValue('effectiveStartDate', editDateFormate(row?.entitlement?.[0]?.validity?.startDate));
      setValue('effectiveEndDate', editDateFormate(row?.entitlement?.[0]?.validity?.endDate));
    } else if (row?.balanceBasedOn === 'Grant') {
      setValue('carryForward', row?.grant?.isCarryForward ? 'Yes' : 'No');
      setValue('numberOfDays', row?.grant?.noOfDays);
      setValue('period', row?.grant?.period);
      setValue('periodfrom', row?.grant?.effectiveAfter?.from);
      setValue('effectiveStartDate', editDateFormate(row?.entitlement?.[0]?.validity?.startDate));
      setValue('effectiveEndDate', editDateFormate(row?.entitlement?.[0]?.validity?.endDate));
    }
  };

  const handleSetEditData = async (row) => {
    setState((prevState) => ({
      ...prevState,
      isModal: { model: true, submit: false },
      editLeaveTypeData: row,
      modalHeader: {
        title: LB_EDIT_LEAVE_TYPE,
        isEdit: true
      }
    }));

    if (row?._id) {
      handleEditApplicable(row);
    }
  };

  const handleMenuScrollToBottom = async () => {
    if (dropdownData.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      employeeDropDownQuery();
    }
  };

  const handleMenuScrollToBottomDesignation = async () => {
    if (designationData.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDesignationDropdown: prevState.currentPageDesignationDropdown + 1
      }));
      designationFetch();
    }
  };

  useEffect(() => {
    if (dropdownData && Array.isArray(dropdownData.data)) {
      setState((prevState) => ({
        ...prevState,
        dropdownDataStore: [...prevState.dropdownDataStore, ...dropdownData.data]
      }));
    }
  }, [dropdownData]);

  useEffect(() => {
    if (designationData && Array.isArray(designationData.data)) {
      setState((prevState) => ({
        ...prevState,
        dropdownDesignationData: [...prevState.dropdownDesignationData, ...designationData.data]
      }));
    }
  }, [designationData]);

  return (
    <div className="container-xxl leave-type-page">
      <header className="leave-type-page__head">
        <h1 className="leave-type-page__title">Leave Type</h1>
      </header>
      <div className="row clearfix g-3">
        <div className="col-sm-12">
          <TableCard>
            <TableToolbar
              onSearch={debouncedOnSearchData}
              actions={
                <button
                  type="button"
                  className="app-table-toolbar__add-btn"
                  onClick={() => {
                    setState({
                      ...state,
                      selectGender: [],
                      selectDepartMentData: [],
                      selectMaritalStatus: [],
                      selectDesignationData: [],
                      selectEmployeeData: [],
                      isModal: { model: true, submit: false },
                      editLeaveTypeData: {},
                      modalHeader: {
                        title: LB_ADD_NEW_LEAVE_TYPE,
                        isEdit: false,
                        editId: ''
                      }
                    });
                    reset();
                  }}
                >
                  <i className="icofont-plus-circle"></i>
                  {BTN_NEW_LEAVE_TYPE}
                </button>
              }
            />
            <div className="card-body">
              <div className="leave-type-table">
                <DataTable
                  customStyles={leaveTypeTableStyles}
                  title={DepartmentsData.title}
                  columns={columnsT}
                  data={leaveTypeData?.data || []}
                  defaultSortField="title"
                  pagination
                  paginationServer
                  onSort={handleChangeSort}
                  sortField={state.sortField}
                  sortDirection={state.sortDirection}
                  paginationTotalRows={paginationRow(
                    // state.isNext,
                    leaveTypeData?.isNext,
                    state.rowsPerPage,
                    state.currentPage,
                    leaveTypeData?.data?.length
                  )}
                  paginationPerPage={state.rowsPerPage}
                  paginationRowsPerPageOptions={[5, 10, 20, 30]}
                  paginationComponentOptions={{
                    noRowsPerPage: false,
                    rangeSeparatorText: 'of',
                    selectAllRowsItem: state.isNext,
                    selectAllRowsItemText: 'All',
                    paginationButtonsDisabled: state.isNext
                  }}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  selectableRows={false}
                  className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                  highlightOnHover={true}
                  noDataComponent={<EmptyData />}
                  progressPending={isLoading || isFetching ? true : false}
                  progressComponent={<TableSkeleton columns={4} />}
                />
              </div>
            </div>
          </TableCard>
        </div>
      </div>
      <DeleteModel
        isOpen={() => {
          setState({ ...state, isDelete: { id: '', status: false } });
        }}
        open={state?.isDelete?.status}
        title={LB_DELETE_LEAVE_TYPE}
        message={LB_DELETE_LEAVE_MESSAGE}
        isDelete={() => {
          handleDeleteLeaveType(state?.isDelete.id);
        }}
      />
      {state?.isModal?.model && (
        <Modal
          centered
          show={state?.isModal?.model}
          size="xl"
          dialogClassName="leave-type-modal"
          contentClassName="leave-type-modal__content"
          onHide={() => {
            reset();
            setState({ ...state, isModal: { model: false, submit: false } });
          }}
        >
          <div className="leave-type-modal__header">
            <div className="leave-type-modal__header-content">
              <span className="leave-type-modal__icon" aria-hidden="true">
                <i className="icofont-calendar" />
              </span>
              <h2 className="leave-type-modal__title">{state?.modalHeader?.title}</h2>
            </div>
            <button
              type="button"
              className="btn-close leave-type-modal__close"
              aria-label="Close"
              onClick={() => {
                reset();
                setState({ ...state, isModal: { model: false, submit: false } });
              }}
            />
          </div>
          <Modal.Body className="leave-type-modal__body">
            <form className="leave-type-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="leave-type-form__panel">
                <section className="leave-type-form__section">
                  <h3 className="leave-type-form__section-title">Details</h3>
                  <div className="leave-type-form__grid leave-type-form__grid--3">
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label" htmlFor="leave-type-name">
                        {LB_NAME}
                      </label>
                      <input
                        id="leave-type-name"
                        type="text"
                        {...register('name')}
                        className="form-control leave-type-form__input--locked"
                        placeholder={LB_NAME}
                        disabled
                      />
                      <small className="text-danger">{getErrorMessage('name', errors)}</small>
                    </div>
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label" htmlFor="leave-type-code">
                        {LB_CODE}
                      </label>
                      <input
                        id="leave-type-code"
                        type="text"
                        placeholder={LB_CODE}
                        {...register('code')}
                        className="form-control"
                      />
                      <small className="text-danger">{getErrorMessage('code', errors)}</small>
                    </div>
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label" htmlFor="leave-type-paid">
                        {LB_TYPE}
                      </label>
                      <select id="leave-type-paid" className="form-control" {...register('type')}>
                        <option value="Paid">Paid</option>
                        <option value="Unpaid">Unpaid</option>
                      </select>
                      <small className="text-danger">{getErrorMessage('type', errors)}</small>
                    </div>
                  </div>
                  <div className="leave-type-form__field leave-type-form__field--last">
                    <label className="leave-type-form__label" htmlFor="leave-type-description">
                      {LB_DESCRIPTION}
                    </label>
                    <textarea
                      id="leave-type-description"
                      {...register('description')}
                      placeholder={LB_DESCRIPTION}
                      className="form-control"
                    />
                    <small className="text-danger">{getErrorMessage('description', errors)}</small>
                  </div>
                </section>
                <section className="leave-type-form__section">
                  <h3 className="leave-type-form__section-title">{LB_BALANCE}</h3>
                  <div className="leave-type-form__pills leave-type-form__pills--choice">
                    <label className="leave-type-form__pill">
                      <input
                        type="radio"
                        {...register('balanceBasedOn')}
                        id="exampleRadios12"
                        value={LB_ENTITLEMENT}
                        checked={values?.balanceBasedOn === LB_ENTITLEMENT ? true : false}
                        onClick={() => setValue('balanceBasedOn', LB_ENTITLEMENT)}
                      />
                      <span>{LB_ENTITLEMENT}</span>
                    </label>
                    <label className="leave-type-form__pill">
                      <input
                        type="radio"
                        {...register('balanceBasedOn')}
                        id="exampleRadios11"
                        value={LB_GRANT}
                        checked={values?.balanceBasedOn === LB_GRANT ? true : false}
                        onClick={() => setValue('balanceBasedOn', LB_GRANT)}
                      />
                      <span>{LB_GRANT}</span>
                    </label>
                  </div>
                  <small className="text-danger">{getErrorMessage('balanceBasedOn', errors)}</small>
                  <h4 className="leave-type-form__subsection">{LB_EFFECTIVE_AFTER}</h4>
                  <div className="leave-type-form__grid leave-type-form__grid--2">
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label" htmlFor="leave-type-start">
                        {LB_EFFECTIVE_START}
                      </label>
                      <input
                        id="leave-type-start"
                        className="form-control"
                        type="date"
                        placeholder="Effective Start Date"
                        {...register('effectiveStartDate')}
                      />
                      <small className="text-danger">
                        {getErrorMessage('effectiveStartDate', errors)}
                      </small>
                    </div>
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label" htmlFor="leave-type-end">
                        {LB_EFFECTIVE_END}
                      </label>
                      <input
                        id="leave-type-end"
                        className="form-control"
                        type="date"
                        placeholder="Effective End Date"
                        {...register('effectiveEndDate')}
                      />
                      <small className="text-danger">
                        {getErrorMessage('effectiveEndDate', errors)}
                      </small>
                    </div>
                  </div>
                  <div className="leave-type-form__grid leave-type-form__grid--rule">
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label" htmlFor="leave-type-carry">
                        {LB_CARRY_FORWARD}
                      </label>
                      <select
                        id="leave-type-carry"
                        className="form-control"
                        {...register('carryForward')}
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                      <small className="text-danger">
                        {getErrorMessage('carryForward', errors)}
                      </small>
                    </div>
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label" htmlFor="leave-type-days">
                        {LB_NO_OF_DAYS}
                      </label>
                      <input
                        id="leave-type-days"
                        className="form-control"
                        type="number"
                        placeholder="No of Days"
                        {...register('numberOfDays')}
                      />
                    </div>
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label" htmlFor="leave-type-period">
                        {LB_PER}
                      </label>
                      <select
                        id="leave-type-period"
                        className="form-select"
                        {...register('period')}
                      >
                        <option value="Month">{EFFECTIVE_PERIOD.MONTH}</option>
                        <option value="Year">{EFFECTIVE_PERIOD.YEAR}</option>
                      </select>
                    </div>
                    {values?.balanceBasedOn === LB_ENTITLEMENT && (
                      <div className="leave-type-form__field">
                        <label className="leave-type-form__label" htmlFor="leave-type-from">
                          {LB_FROM}
                        </label>
                        <select
                          id="leave-type-from"
                          className="form-select"
                          {...register('periodfrom')}
                        >
                          <option value="Date of Joining">{EFFECTIVE_FROM.DATE_OF_JOINING}</option>
                          <option value="Date of Confirmation">
                            {EFFECTIVE_FROM.DATE_OF_CONFIRMATION}
                          </option>
                        </select>
                      </div>
                    )}
                  </div>
                </section>
                <section className="leave-type-form__section">
                  <h3 className="leave-type-form__section-title">{LB_APPLICABLE}</h3>
                  <div className="leave-type-form__split">
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label">{LB_GENDER_LABEL}</label>
                      <div className="leave-type-form__pills">
                        {GENDER_OPTION.map((checkbox) => (
                          <label className="leave-type-form__pill" key={checkbox.value}>
                            <input
                              type="checkbox"
                              value={checkbox.value}
                              checked={state.selectGender?.includes(checkbox.value)}
                              onChange={handleCheckboxChange}
                            />
                            <span>{checkbox.label}</span>
                          </label>
                        ))}
                      </div>
                      <small className="text-danger">{getErrorMessage('gender', errors)}</small>
                    </div>
                    <div className="leave-type-form__field">
                      <label className="leave-type-form__label">{LB_MARITAL_STATUS_LABEL}</label>
                      <div className="leave-type-form__pills">
                        {MARITAL_STATUS_OPTION.map((checkbox) => (
                          <label className="leave-type-form__pill" key={checkbox.value}>
                            <input
                              type="checkbox"
                              value={checkbox.value}
                              checked={state.selectMaritalStatus?.includes(checkbox.value)}
                              onChange={handleMaritalStatusCheckboxChange}
                            />
                            <span>{checkbox.label}</span>
                          </label>
                        ))}
                      </div>
                      <small className="text-danger">
                        {getErrorMessage('maritalStatus', errors)}
                      </small>
                    </div>
                  </div>
                  <div className="leave-type-form__field">
                    <label className="leave-type-form__label">{LB_DESIGNATION_LABEL}</label>
                    <Select
                      classNamePrefix="lt-select"
                      isMulti
                      menuPlacement="top"
                      placeholder="Select Designation..."
                      options={[
                        { value: '-1', label: 'Select All Designation' },
                        ...(state.dropdownDesignationData?.map((val) => ({
                          value: val._id,
                          label: val?.name
                        })) || [])
                      ]}
                      onMenuScrollToBottom={handleMenuScrollToBottomDesignation}
                      onChange={(selectedOption) => {
                        setState({
                          ...state,
                          selectDesignationData: selectedOption
                            .filter((data) => data)
                            .map((data) => (data?.value === '-1' ? '-1' : data?.value))
                        });
                      }}
                      value={
                        state.selectDesignationData &&
                        state.selectDesignationData.length > 0 &&
                        state.selectDesignationData.includes('-1')
                          ? [{ value: '-1', label: 'Select All Designation' }]
                          : state.selectDesignationData.map((value) => ({
                              value,
                              label: state.dropdownDesignationData.find(
                                (item) => item._id === value
                              )?.name
                            }))
                      }
                    />
                  </div>
                  <div className="leave-type-form__or">{LB_OR}</div>
                  <div className="leave-type-form__field">
                    <label className="leave-type-form__label">{LB_LB_EMPLOYEE}</label>
                    <Select
                      classNamePrefix="lt-select"
                      isMulti
                      menuPlacement="top"
                      placeholder="Select Employee..."
                      options={[
                        { value: '-1', label: 'Select All Employees' },
                        ...(state.dropdownDataStore?.map((val) => ({
                          value: val._id,
                          label: val?.name
                        })) || [])
                      ]}
                      onMenuScrollToBottom={handleMenuScrollToBottom}
                      onChange={(selectedOption) => {
                        setState({
                          ...state,
                          selectEmployeeData: selectedOption
                            .filter((data) => data)
                            .map((data) => (data?.value === '-1' ? '-1' : data?.value))
                        });
                      }}
                      // defaultValue={
                      //   state?.editLeaveTypeData?.applicable?.employee?.length > 0 &&
                      //   state?.editLeaveTypeData?.applicable?.employee
                      //     .filter(({ _id }) => _id !== '-1')
                      //     .map(({ _id }) => ({
                      //       value: _id,
                      //       label: state.dropdownDataStore.find((v) => v._id === _id)?.name
                      //     }))
                      // }
                      value={
                        state.selectEmployeeData &&
                        state.selectEmployeeData.length > 0 &&
                        state.selectEmployeeData.includes('-1')
                          ? [{ value: '-1', label: 'Select All Employees' }]
                          : state.selectEmployeeData.map((value) => ({
                              value,
                              label: state.dropdownDataStore.find((item) => item._id === value)
                                ?.name
                            }))
                      }
                    />
                  </div>
                </section>
                <div className="leave-type-form__footer">
                  <button type="submit" disabled={state.loading} className="leave-type-form__save">
                    {state.loading ? (
                      <span className="spinner-border spinner-border-sm" role="status" />
                    ) : (
                      BTN_SAVE
                    )}
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}

export default LeaveType;
